module.exports = __webpack_public_path__ + "img/red-cross.82ee6db2.svg";